import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { date } from "../../shared/src/codecs/types/date";
import { dateTime } from "../../shared/src/codecs/types/dateTime";
import { literal } from "../../shared/src/codecs/types/literal";
import { longString } from "../../shared/src/codecs/types/longString";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";

// Only the contractual deadlines; the two expected_* key dates are forecasts and are
// deliberately not logged. See docs/adr/0022.
export const CaseDeadlineType1 = union([
    literal("exchange"),
    literal("completion"),
]);
export type TCaseDeadlineType1Codec = typeof CaseDeadlineType1;
export type TCaseDeadlineType1 = TTypeOfCodec<typeof CaseDeadlineType1>;

export const caseDeadlineTypeColumn: Record<TCaseDeadlineType1, "exchange_deadline" | "completion_deadline"> = {
    exchange: "exchange_deadline",
    completion: "completion_deadline",
};

export const CaseDeadlineChangeSource1 = union([
    literal("rule"),
    literal("manual"),
    literal("backfill"),
]);
export type TCaseDeadlineChangeSource1Codec = typeof CaseDeadlineChangeSource1;
export type TCaseDeadlineChangeSource1 = TTypeOfCodec<typeof CaseDeadlineChangeSource1>;

// Not a UserName overload: that renders "Name not given" for the rule's absent actor,
// which reads as a missing record rather than as no actor at all.
export const CasesDeadlineChange = required({
    id: uuid(),
    case_id: uuid(),
    deadline_type: CaseDeadlineType1,
    previous_date: union([nullCodec(), date()]),
    deadline_date: date(),
    source: CaseDeadlineChangeSource1,
    reason: longString(),
    set_by_name: union([nullCodec(), string()]),
    created_at: dateTime(),
});
export type TCasesDeadlineChangeCodec = typeof CasesDeadlineChange;
export type TCasesDeadlineChange = TTypeOfCodec<typeof CasesDeadlineChange>;
